import { LoadSpinner } from '@calizahq/react-components-v2'
import { BookablePerson } from '@sales-app/context/workspace/workspace.type'
import { PeopleQueries } from '@sales-app/graphql/queries/people.queries'
import { CreateComment } from '@sales-app/views/Comment/CreateComment'
import React, { FC } from 'react'

import { Card } from '@/components'
import { useGraphql } from '@/hooks/useGraphql'
import { compareDates } from '@/util'

import { CommunicationLog } from './CommunicationLog'

type Props = {
  bookablePerson: BookablePerson
}

export const CommunicationLogs: FC<Props> = ({ bookablePerson }) => {
  const { isLoading, data, refetch } = useGraphql<PeopleQueries.GET_BOOKABLE_PERSON_ACTIVITY.Response>(
    PeopleQueries.getBookablePersonActivity.name,
    PeopleQueries.getBookablePersonActivity(),
    {
      bookablePersonRecord: {
        bookablePersonId: bookablePerson.bookablePersonId,
        bookablePersonType: bookablePerson.bookablePersonType,
      },
    },
  )

  const activityFeed = data?.bookablePerson?.activityFeed || []
  activityFeed.sort((a, b) => compareDates(a.datetime, b.datetime))

  return (
    <div className="flex flex-col w-full">
      <div className="flex w-full ">
        {isLoading ? (
          <div className="flex h-20 w-full items-center justify-center">
            <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
          </div>
        ) : (
          <>
            {activityFeed.length > 0 ? (
              <div className=" mb-4 flex max-h-[70vh] w-full flex-col-reverse overflow-y-auto rounded-lg border p-4 border-secondary">
                {activityFeed.map((activity, i) => (
                  <CommunicationLog
                    activity={activity}
                    bookablePersonName={data?.bookablePerson?.fullName || ''}
                    key={i}
                  />
                ))}
              </div>
            ) : (
              <Card cardClassName="mb-4" headerText="All History">
                <div className="flex w-full flex-col p-4">No Communication logs</div>
              </Card>
            )}
          </>
        )}
      </div>
      <div>
        <CreateComment
          commentableId={bookablePerson.bookablePersonId}
          commentableType={bookablePerson.bookablePersonType}
          refetchOnSuccess={refetch}
        />
      </div>
    </div>
  )
}
